import {Module} from 'vuex';
import oApi from '@/js/hvac/talk/appoint.js'
import {commonVuex} from "../common.js";

/**
 * 用户分享数据模块
 * @type {Module}
 */
export const userTalkAppoint = {
    namespaced: true,
    state: {
        SupportData:[],//支持人员列表
        CustomerData:[],//选择用户列表
        TemplateRoomData:[],//样板间列表
        ReportTimeData:[],//预约时间列表
        ReportUserInfoData:{},//报告信息,用户信息
        ReportTagsData:[],//报告信息， 标签组
        ReportRestData:[],//休息日列表
        ReportListData:[],//报告列表
        ReportId:'',//报告id
        ReportCount:{},
        distance:'',//2点之间的距离
        AgreementData:'',//隐私协议
        CustomerObj:{},//'默认带出的潜客'
    },
    mutations: {
        SaveSupportData (state,payload) {
            state.SupportData = [...state.SupportData,...payload]
        },
        
        SaveSupportData2 (state,payload) {
            state.SupportData = payload
        },
        SaveCustomerObj (state,payload) {
            state.CustomerObj = payload[0]
        },
        SaveCustomerData (state,payload) {
            state.CustomerData = payload
        },
        SaveTemplateRoomData (state,payload) {
            state.TemplateRoomData = payload
        },
        SaveReportTimeData (state,payload) {
            state.ReportTimeData = payload
        },
        SaveReportAppointData (state,payload) {
            state.ReportAppointData = payload
        },
        SaveReportUserInfoData (state,payload) {
            state.ReportUserInfoData = payload
        },
        SaveReportTagsData (state,payload) {
            state.ReportTagsData = payload
        },
        SaveReportRestData (state,payload) {
            state.ReportRestData = payload
        },
        SaveReportListData (state,payload) {
            state.ReportListData = payload
        },
        SaveReportListDatas (state,payload) {
            state.ReportListData = [...state.ReportListData,...payload]
        },
        SaveAgreement (state,payload) {
            state.AgreementData = payload
        },
        SaveReportId (state,payload) {
            state.ReportId = payload
        },
        SaveDistance (state,payload) {
            console.log(payload,'payload');
            payload = payload.split(',')
            let distance = 0
            for (let index = 0; index < payload.length; index++) {
                distance += payload[index] * 1000 **(payload.length-index-1)
            }
            state.distance = distance
        },
        SaveReportCount (state,payload) {
            // console.log(parseInt(payload.list[1].num),'useraccount1');
            // console.log(parseInt(payload.list[2].num),'useraccount2');//接受邀请
            // console.log((payload.list),'useraccount3');//已体验
            // let Invite = parseInt(payload.list[2].num)/(parseInt(payload.list[1].num) + parseInt(payload.list[2].num))
            // let Experience = parseInt(payload.list[3].num)/(parseInt(payload.list[3].num) + parseInt(payload.list[2].num))
            // Invite=  Math.round(Number(Invite)*100)
            // Experience=  Math.round(Number(Experience)*100)
            let Invite= parseInt(payload.list[2].num)/parseInt(payload.count)
            let Experience= parseInt(payload.list[3].num)/parseInt(payload.count)
            Invite=  Math.round(Number(Invite)*100)
            Experience=  Math.round(Number(Experience)*100)
            let zero = false
            if (payload.count == 0) {
                zero = true
            }
            state.ReportCount = {
                Invite,
                Experience,
                zero
            }
        },
        RemoveReport (state,payload) {
            state.ReportId = ''
            const {user} = payload
            let ReportTimeData = state.ReportTimeData
            ReportTimeData.map(element => {
                element.map (item => {
                    if (item.report.uname == user) {
                        item.report = {}
                    }
                    return item
                })
                return element
            });
        },
        chooseStatus (state,payload) {

                const {index,index2} = payload
                let ReportTimeData = state.ReportTimeData
                ReportTimeData = ReportTimeData.map ( (ele,i) => {
                    const eleList2 = ele.map( (ele2,i2) => {
                        if (i == index && i2 == index2) {
                            // console.log( Object.keys(ele2.report).length,'report');
                           ele2.report = []
                        }
                        return ele2
                    })
                    return eleList2
                })
                state.ReportTimeData = ReportTimeData
        },
        // 填写超时原因修改
        addOverTimeInfo (state,payload) {
            const {id,mark_out} = payload
            console.log(payload,'payload');
            let obj = state.ReportListData.find (i => {
                return i.id == id
            })
            obj.mark_out = mark_out
        },
    },
    actions: {
        // 获取支持人员的数据
        async getSupportData ({state,commit},payload) {
            console.log('触发函数');
            await oApi.getSupport(payload).then (res => {
                const list = res.data.result.list
                commit('SaveSupportData',list)
            })
        },
        async getSupportData2 ({state,commit},payload) {
            await oApi.getSupport(payload).then (res => {
                const list = res.data.result.list
                commit('SaveSupportData2',list)
            })
        },
        async getCustomerData({state,commit},payload) {
            await oApi.getCustomer(payload).then (res => {
                const list = res.data.result.list
                commit('SaveCustomerData',list)
            })
        },
        // 默认带出潜客
        async getCustomerObj({state,commit},payload) {
            await oApi.getCustomer(payload).then (res => {
                const list = res.data.result.list
                commit('SaveCustomerObj',list)
            })
        },
        async SendReportShare({state,commit},payload) {
            await oApi.ReportShare(payload).then (res => {
            })
        },
        async getTemplateRoomData({state,commit},payload) {
            await oApi.getTemplateRoom(payload).then (res => {
                let list = res.data.result.list
                list = list.map (item => {
                    // 判断new_community是否存在，存在就使用他，不存在就使用new_address替代
                    if (!item.new_community) {
                        item.templateName = item.new_address
                    } else {
                        item.templateName = item.new_community
                    }
                    return item
                })
                commit('SaveTemplateRoomData',list)
            })
        },
        async getReportTimeData({state,commit},payload) {
            await oApi.getReportTime(payload).then (res => {
                // console.log(res,'times');
                const list = res.data.result.list
                let timeList = []
                let threelist = []
                for (let index = 0; index < list.length; index++) {
                    threelist.push(list[index])
                    if((index + 1) % 3 == 0) {
                        timeList.push(threelist)
                        timeList.push(threelist)
                        threelist = []
                    }
                }
                if (threelist.length != 0) {
                    timeList.push(threelist)
                    timeList.push(threelist)
                }
                // console.log(timeList,'list');
                commit('SaveReportTimeData',timeList)
            })
        },
        // 样板间预约
        async getReportAppointData({state,commit},payload) {
            console.log(1232121213);
            // conoApi.st ReportTimeData = state.ReportTimeData
            await oApi.getReportAppoint(payload).then (res => {
                // console.log(res,'样板间预约');
                const list = res.data.result.list
                // commit('SaveReportAppointData',list)
            })
        },
        // 获取报告信息
        async getReportId({state,commit},payload) {
            await oApi.getReportinfo(payload).then (res => {
                // console.log(res,'报告详情');
                const result = res.data.result
                commit('SaveReportId',result.infos.id)
            })
        },
        // b端报告详情
        async getReportInfoData({state,commit},payload) {
            await oApi.getReportinfo(payload).then (res => {
                // console.log(res,'报告详情');
                const result = res.data.result
                commit('SaveReportUserInfoData',result.infos)
                commit('SaveReportTagsData',result.tags)
            })
        },
        async getCReportInfoData({state,commit},payload) {
            await oApi.getCreportInfoData(payload).then (res => {
                console.log(res,'报告详情');
                const result = res.data.result
                commit('SaveReportUserInfoData',result.infos)
                commit('SaveReportTagsData',result.tags)
            })
        },
        async getReportRestData({state,commit},payload) {
            await oApi.getReportRest(payload).then (res => {
                // console.log(res,'休息日');
                const list = res.data.result.list
                commit('SaveReportRestData',list)
            })
        },
        async getReportConfigData({state,commit},payload) {
            await oApi.getReportConfig(payload).then (res => {
                // console.log(res,'报告需求');
                const list = res.data.result.list
            })
        },
        // 报名列表
        async getReportListData({state,commit},payload) {
            await oApi.getReportlist(payload).then (res => {
                console.log(res,'报告列表');
                const result = res.data.result
                commit('SaveReportListData',result.list)
                commit('SaveReportCount',{count:result.num_account,list:result.count})
            })
        },
        // 新增报名列表（下拉触底刷新）
        async getReportListDatas({state,commit},payload) {
            await oApi.getReportlist(payload).then (res => {
                console.log(res,'报告列表');
                const result = res.data.result
                commit('SaveReportListDatas',result.list)
            })
        },
        // 预约回顾
        async getReportList({state,commit},payload) {
            // conoApi.sole.log(payload);
            await getReportlist(payload).then (res => {
                console.log(res,'huigu');
                const result = res.data.result
                commit('SaveReportList',result.list)
                // commit('SaveReportCount',result.count)
            })
        },
        // 取消预约
        async SendReportCancel({state,commit},payload) {
            await oApi.ReportCancel(payload).then (res => {
                // console.log(res,'取消预约');
            })
        },
        // 接受邀请
        async SendDiscussAccept({state,commit},payload) {
            await oApi.DiscussAccept(payload).then (res => {
                console.log(res,'接受邀请');
            })
        },
        async SendSignIn({state,commit},payload) {
            await oApi.SignIn(payload).then (res => {
                console.log(res,'接受邀请');
            })
        },
        async SendCheckSignIn({state,commit},payload) {
            await oApi.CheckSignIn(payload).then (res => {
                const data = res.data.result
                commit('SaveDistance',data.distance)
            })
        },
        async getAgreementData({state,commit},payload) {
            await oApi.getAgreement(payload).then (res => {
                const data = res.data.result
                commit('SaveAgreement',data.content)
                console.log(data);
            })
        },
        async SendcancelAppoint({state,commit},payload) {
            await oApi.cancelAppoint(payload).then (res => {
                console.log(res,'取消');
            })
        },
        async SendReportappoints({state,commit},payload) {
            await oApi.getReportappoints(payload).then (res => {
                console.log(res,'同时预约多个时间段');
            })
        },
        async SendreportoutInfo({state,commit},payload) {
            await oApi.Sendreportout(payload).then (res => {
            })
        },
    },
    getters: {},
    modules:{
        commonVuex
    }
}

